import React, { Component } from 'react';
import './Help.scss'
import { Banner } from '../../Components'
import { Helmet } from "react-helmet"


class About extends Component {

    componentDidMount() {
        window.scrollTo(0,0)
    }
    
    render() {
        return (
            <div>
				<Helmet>
					<title>Help | GPbook</title>
				</Helmet>	
                <Banner title="Help" subtitle="Frequently Asked Questions and Answers" />
                <div className="page about-page">
                    <Helping />
                </div>
            </div>
        );
    }
}

const Helping = () =>
    <div className="container help-about-gpbook">
		<div className="row">
			<div className="col-lg-6">
			<h3>For Users Accessing the Directory</h3>
		<div className="question">
			<h4>I’ve forgotten my login information</h4>
			<p>You can request your login information to be sent to you by using the <a href="https://online.gpbook.com.au/login/gp/reset">Forgot Password</a> link. This link can also be found at the bottom of the login page.
			</p>
		</div>
		<div className="question">
			<h4>I need a copy of my invoice</h4>
			<p>Invoices are accessible through your ‘Account Manager’ when you have logged in. After logging into the portal, hover over your name at the top right of the screen and select ‘Account Manager’. Then select ‘Invoices’. Here, you will be able to download all previous invoices.</p>
		</div>
		<div className="question">
			<h4>I’d like to increase the number of users at my practice</h4>
			<p>You can do this through the ‘Account Manager’. After logging into the portal, hover over your name at the top right of the screen and select ‘Account Manager’. Select 'Subscriptions' and update the number of subscriptions you need.</p>
		</div>
       <hr></hr>

		
			</div>
			<div className="col-lg-6">
			<h3>For Specialists Listing With Us</h3>  
		<div className="question">
			<h4>I've forgotten my login information to update my information</h4>
			<p> Send an email to info@gpbook.com.au from your practice email address to request for your login information.</p>
		</div>
        <p></p>
			</div>
		</div>
    </div>  


export default About;


// WEBPACK FOOTER //
// ./src/Containers/Help/Help.js